(function () {
    'use strict';

    angular.module("imApp").factory("poFinishProdCompQtyService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 167,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 182,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
